import { TbLink } from '@website-builder/model/domain/link/tb-link';
import { makeEntityId } from '@website-builder/util/make-widget-id.utility';
import { EntityIdPrefix } from '@website-builder/model/domain/entity-id-prefix.enum';

export class AccordionElement {
  id = makeEntityId(EntityIdPrefix.WIDGET_ELEMENT);
  title = 'Title';
  content =
    'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.3/4 Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.4';
  imageSrc: string;
  imageSrcImageKey = null;
  imageAlignment = 'uk-flex-column';
  buttonText?: string;
  link = new TbLink();

  constructor(src?: string) {
    this.imageSrc = src;
  }

  static normalizeInPlace(element: AccordionElement): AccordionElement {
    const pureElement = new AccordionElement();

    element.title = element.title ?? pureElement.title;
    element.content = element.content ?? pureElement.content;
    element.imageSrc = element.imageSrc ?? pureElement.imageSrc;
    element.imageSrcImageKey = element.imageSrcImageKey ?? pureElement.imageSrcImageKey;
    element.imageAlignment = element.imageAlignment ?? pureElement.imageAlignment;
    element.buttonText = element.buttonText ?? pureElement.buttonText;
    element.link = TbLink.normalizeInPlace(element.link ?? pureElement.link);

    return element;
  }
}
